module.exports = __webpack_public_path__ + "static/media/_MG_5362.be41ed0a.jpg";